class BonCartRemove extends HTMLElement {
  constructor() {
    super();
    $(this).on('click', (event) => {
      let url = $(this).attr('data-href'),
        dataIndex = $(this).attr('data-index'),
        boncartElement = document.querySelector('boncart-element');
      this.enableLoading();
      fetch(url)
        .then((response) => {
          boncartElement.getCartItems();
          setTimeout(() => {
            
            if ($('.boncart-wrapper').length <= 1) {
              $('.cart-notification__links').css('display', 'none');
            }
          }, 1000);
        })
        .then(() =>
        setTimeout(() => {
            let count = $('.cart-item').length;
            $('.cart-count-bubble span').text(count);
            this.disableLoading();
          }, 2000)
        );

      $('cart-remove-button').each(function () {
        let self = $(this);
        if (dataIndex == self.attr('data-index')) {
          $(self).trigger('click');
        }
      });
    });
  }

  enableLoading() {
    $('.boncart-wrapper').addClass('active-remove');
    $('#boncart-summary-product-list .loading-overlay__spinner').removeClass(
      'hidden'
    );
  
  }

  disableLoading() {
    $('.boncart-wrapper').removeClass('active-remove');
    $('#boncart-summary-product-list .loading-overlay__spinner').addClass(
      'hidden'
    );
  }
}

customElements.define('boncart-remove-button', BonCartRemove);

class BonCart extends HTMLElement {
  constructor() {
    super();
    $('.product-form__buttons').on('click', this.getCartItems.bind(this));
  }

  getCartItems() {
    setTimeout(() => {
      fetch('/?section_id=boncart-item')
        .then((response) => response.text())
        .then((data) => this.renderContents(data));
    }, 1000);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState);
    });
    if ($('.boncart-wrapper').length > 0) {
      $('.cart-notification__links').css('display', 'block');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-ajax-element'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('boncart-element', BonCart);

$('.widget-cart.full_screen #cart-icon-bubble, .boncart-backdrop, .widget-cart.full_screen .popup-close').on('click', function (e) {
  $('body').toggleClass('active');
  $('.widget-cart.full_screen').toggleClass('active');
});

document.addEventListener("DOMContentLoaded", cartPopupMobile);
window.addEventListener("resize", cartPopupMobile);

function cartPopupMobile() {
  if (window.screen.width < 1200 ) {
    const boncartIcon = document.querySelector('.dropdown_cart');
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink != undefined) {
      cartLink.onclick = function (event) {
        event.preventDefault();
      }
    }
    if (boncartIcon != undefined) {
      boncartIcon.onclick = function (event) {
        const boncartList = document.getElementById('boncart-summary-product-list');
        if (boncartList.style.visibility === "hidden" || boncartList.style.visibility == '') {
          boncartList.style.cssText  = "visibility : visible; opacity : 1; transform: translateY(-5px)";
        } else {
          boncartList.style.cssText = "visibility: hidden;  opacity: 0;";
        }
      }
    }
  }
}